export default __webpack_public_path__ + "static/logo-globe-581668c498fb75856f1ae8cde6bf66ed.png";